import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from 'axios';
import { CustomerSummary } from '../components/CustomersComponents';
import { BasicTable, toUserTimezone } from '../components/utility/Utility';
import '../assets/css/components/program.css';
import { ActionDescription } from '../components/Onboarding';

export default function Customer() {
    const {handleSignOut, getJwtToken, userProfile} = useContext(AuthContext);
    const [customer, setCustomer] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [tutorial, setTutorial] = useState(0);
    const navigate = useNavigate();
    let { id } = useParams();
    const timezone = userProfile?.store?.settings?.timezone;

    useEffect(() => {
        const fetchCustomerData = async () => {
            const tutorial = searchParams.get('tutorial');
            if (tutorial === 'true') setTutorial(1);
    
            try {
                const token = await getJwtToken();
                const res = await axios.get(
                    'https://api.amplifyloyalty.com/app/customers',
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        params: {
                            _id: id,
                            tutorial
                        }
                    }
                );
    
                let resData = {
                    ...res.data,
                    events: res.data.events.sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()),
                    orders: res.data.orders.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                };
                console.log(resData);
                setCustomer(resData);
            } catch (err) {
                console.log(err);
                // Consider calling logout() on auth errors
            }
        };

        if (id && getJwtToken) {
            fetchCustomerData();
        }
    }, [id, getJwtToken]);

    return (
        <div className="main">
            <CustomerSummary 
                customer={customer} 
                setCustomer={setCustomer} 
                tutorial={tutorial}
                setTutorial={setTutorial}
                logout={handleSignOut}
            />
            {tutorial === 2 && <div className="popup-overlay"></div>}
            <div className="customer-history centralize" style={tutorial === 2 ? {
                position: "relative", 
                zIndex: "55", 
                backgroundColor: "#fff",
                boxShadow: "0 0 10px #fff",
            } : {position: "relative"}}>
                {tutorial === 2 && 
                    <ActionDescription 
                        text={`View customer engagement with your shop and your loyalty program.`}
                        style={{width: "200px", right: "calc(50% - 110px)", top:"-115px", textAlign: "left"}}
                        triangle={{bottom: "-18px", left: "calc(50% - 9px)", transform: "rotate(180deg)"}}
                        tutorial={tutorial}
                        setTutorial={setTutorial}
                        hidePopup={true}
                        next="Next"
                    />
                }
                {/* Add available rewards. Give ability to remove them from their account */}
                <BasicTable 
                    header="Order History"
                    className="customer-orders"
                    data={customer.orders} 
                    keys={{
                        'created_at': {
                            name: 'Time',
                            format: (v) => {
                                if (!timezone) return '...';
                                let date = toUserTimezone(timezone, new Date(v));
                                return (`${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`)
                            }
                        }, 
                        'order_number': {
                            name: 'Order Number',
                            format: (v) => v
                        },
                        'subtotal': {
                            name: 'Subtotal',
                            format: (v) => Intl.NumberFormat('en-us', {style: 'currency', currency: 'USD'}).format(v)
                        }
                    }}
                />
                <BasicTable 
                    className="customer-events"
                    data={customer.events}
                    keys={{
                        'time': {
                            name: 'Time',
                            format: (v) => {
                                if (!timezone) return '...';
                                let date = toUserTimezone(timezone, new Date(v));
                                return (`${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`)
                            }
                        },
                        'name': {
                            name: 'Action',
                            format: (v) => v
                        },
                        'points': {
                            name: 'Points',
                            format: (v) => Intl.NumberFormat('en-us').format(v)
                        }
                    }}
                    header="Loyalty Program Engagement"
                    style={tutorial === 8 ? {
                        position: "relative", 
                        zIndex: "55", 
                        backgroundColor: "#fff",
                        boxShadow: "0 0 10px #fff",
                        borderRadius: "var(--small-border-radius)"
                    } : {}}
                />
                {tutorial === 8 && 
                    <ActionDescription 
                        text={`Your adjustment will be added to the Engagement table. Click Finish to complete this tutorial and return to the Customers page.`}
                        style={{width: "250px", right: "calc(50% - 135px)", top:"90px", textAlign: "left"}}
                        triangle={{bottom: "-18px", left: "calc(50% - 9px)", transform: "rotate(180deg)"}}
                        tutorial={tutorial}
                        setTutorial={setTutorial}
                        finish={async () => {
                            try {
                                const token = await getJwtToken();
                                await axios.put(
                                    'https://api.amplifyloyalty.com/app/stores/onboarding',
                                    {section: "customers"},
                                    {
                                        headers: {
                                            Authorization: `Bearer ${token}`
                                        }
                                    }
                                );
                                navigate('/app/customers');
                            } catch (err) {
                                console.log(err);
                            }
                        }}
                    />
                }
            </div>
        </div>
    )
}